const initialState = {
  accounts: {
    fetching: false,
    fetched: false,
    fetching_single: false,
    fetched_single: false,
    pagination: {
      page: 1,
      per_page: 10,
      total_pages: 1
    },
    accounts: [],
    filter_query: {
      query: '',
      account_data: {},
      account_names: {}
    },
    must_redirect: false,
    query: '',
    account_data: {},
    account_names: {},
    filters: [],
    errors: [],
    sort: '',
    order: ''

  },

  auth: {
    isAuthenticated: false,
    isLoggingIn: false,
    isLoggingOut: false,
    isSubmitting: false,
    isValidating: false,
    tokenInvalid: false,
    current_user: {
      data: {},
      errors: []
    }
  },

  entries: {
    fetching: false,
    fetched: false,
    updating: false,
    pagination: {
      page: 1,
      per_page: 100,
    },
    dry: null,
    filters: [],
    keys: [],
    removed_keys: [],
    counters: [],
    errors: [],
    items: [],
    sort: '',
    order: ''
  },

  feeds: {
    fetching: false,
    fetching_page: false,
    fetched: false,
    mustRedirect: false,
    showingProject: false,
    showingProjectArchive: false,
    creating_optimized: false,
    adding_columns: false,
    removing_column: false,
    feed: {
      optimizations: [],
      archives: []
    },
    pagination: {
      page: 1,
      per_page: 10,
      total_pages: 1
    },
    errors: [],
    items: []
  },

  reports: {
    fetching: false,
    fetching_page: false,
    fetched: false,
    mustRedirect: false,
    showingProject: false,
    showingProjectArchive: false,
    creating_optimized: false,
    adding_columns: false,
    removing_column: false,
    report: {
      optimizations: [],
      archives: [],
      status: ''
    },
    pagination: {
      page: 1,
      per_page: 10,
      total_pages: 1
    },
    errors: [],
    items: []
  },

  preferences: {
    fetching: false,
    fetched: false,
    fetching_single: false,
    fetched_single: false,
    errors: [],
    preferences: {
      maximum_title_length: {
      }
    }
  },

  scripts: {
    fetching: false,
    fetched: false,
    fetching_single: false,
    fetched_single: false,
    errors: [],
    items: []
  },

  users: {
    fetching: false,
    fetched: false,
    fetching_single: false,
    fetched_single: false,
    must_redirect: false,
    pagination: {
      page: 1,
      per_page: 10,
      total_pages: 1
    },
    filters: [],
    errors: [],
    sort: '',
    order: ''
  }

}

export default initialState



// WEBPACK FOOTER //
// ./src/js/store/initialState.js